import Config from "@_configs/api.config";
import { handleResponse, sessionHeader } from "@_utils/helpers";

export const authService = {
  login,
};

function login(caseNumber, pin, host, user_id, user_device_info) {
  let uri = `${Config.API_ROOT}cases/${caseNumber}/authenticate?host=${host}`;

  const requestOptions = {
    method: "POST",
    headers: { ...sessionHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ pin, user_id, user_device_info }),
  };

  return fetch(uri, requestOptions)
    .then(handleResponse)
    .then((user) => {
      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("case_id", caseNumber);
      return user;
    });
}
